export const HeaderStyle = {

  variants: {
    wrapper: {
      mobileWarning: {
        background: 'ORANGE',
        color: 'white',
        textAlign:"center",
        fontWeight:"bold",
        padding:'.5rem 0',
      },
      tooltip: {
        bg:"ORANGE",
        color:"BLACK",
        fontWeight:600,
        borderRadius:99,
      },
      navActionsButtonText: {
        color: "ORANGE",
        fontSize: 32,
      },
      link: {
        color:"ORANGE",
        fontSize:32,
        paddingLeft:"8px",
        paddingRight:"8px",
      },
    },
  },
};

